import React from 'react';
import { useObserver, useLocalStore } from 'mobx-react-lite';
import styled from 'styled-components/macro';
import { useMst } from '../models/WithWineState';
import Modal from './Modal';
import AddressSelectForm from './AddressSelectForm';
import { AddressContainerProps } from '../types/AddressContainerProps';
import { useAddressSelectStore } from '../models/AddressSelect';
import Button from './Button';

const UnstyledAddressSelectModal: React.FC<AddressContainerProps> = ({
  className,
  selectmessage: selectMessage,
  changemessage: changeMessage,
}) => {
  const formState = useAddressSelectStore();
  const stateTree = useMst();
  const state = useLocalStore(() => ({
    onEditAddressComplete() {
      this.hide();
    },
    get isOpen() {
      return stateTree.widgets.addressSelectModal.open;
    },
    hide() {
      stateTree.widgets.addressSelectModal.hide();
    },
  }));

  const onSave = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    if (formState.hasPostcodeEntry) {
      formState.onCalculateCart();
    }
    state.hide();
  };

  return useObserver(() => (
    <Modal
      className={'ww-widget ww-address-select-modal ' + (className || '')}
      open={state.isOpen}
      onBackdropClick={state.hide}
      header={
        <h3 className="header">
          {selectMessage || changeMessage || 'Select Location'}
        </h3>
      }
      footer={
        <div className="actions">
          <Button primary solid onClick={onSave}>
            Save
          </Button>
        </div>
      }
    >
      <AddressSelectForm />
    </Modal>
  ));
};

const AddressSelectModal = styled(UnstyledAddressSelectModal)``;

export default AddressSelectModal;
